module.exports = __webpack_public_path__ + "static/media/circ-cross-thin-red.f44c4d5e.svg";